var http = require('http');
console.log('../../config/' + process.env.APP_CONFIG + '.json');

var config = require('../../config/' + process.env.APP_CONFIG + '.json');
function  callErrorCallback(inError,inScope, inResult){
    var error = inResult.error;
    if (inError) {
        inError.call(inScope, inResult);
    } else {
        console.error(error.info||error.errorInfo);
    }
}
function createUIID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
var uiid = createUIID();
var token;
var ajax = function(inOpts){
    var opts = inOpts || {};
    var data = opts.data || {};
    var error = opts.error;
    var scope = opts.scope;
    var bodyString = JSON.stringify({
        cmd:opts.cmd,
        parameters:data,
        clientIdentifierCode: uiid,
        token:token
    });
    var success = opts.success;
    console.log(bodyString);
    var headers = {
        'Content-Type': 'application/json',
        'Content-Length': bodyString.length
    };
    var options = {
        host: config.serverSideCgiHost,
        path: config.path,
        port: config.port,
        method: 'POST',
        headers: headers
    };
    var req = http.request(options, function(response) {
        var data = '';
        console.log('in request');

        //another chunk of data has been recieved, so append it to `str`
        response.on('data', function(chunk) {
            data += chunk;
        });

        //the whole response has been recieved, so we just print it out here
        response.on('end', function() {
            console.log('data:'+data);
            var json = JSON.parse(data);
            if(json.error){
                callErrorCallback(error,scope,inResult);
            }else{
                switch (json.statusCode) {
                    case 0:
                        var response = json.response;
                        if (success) {
                            success.call(scope, response);
                        }
                        break;
                    case 412:
                    case 401:
                    case 403:
                    case 410:
                    case 500:
                        callErrorCallback(error,scope,json);
                        break;
                    default:
                }
            }
        });
    }).on('error', function(error) {
        console.error(error.status);
    }).write(bodyString);
};
module.exports = {
    ajax:ajax,
    setToken:function (inToken) {
        token = inToken
    }
};



//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/sio.js
// module id = 117
// module chunks = 0 1 4